module.exports = __webpack_public_path__ + "img/404.76a1a66a.png";